import { render, staticRenderFns } from "./Record.vue?vue&type=template&id=78a6a872&"
import script from "./Record.vue?vue&type=script&lang=ts&"
export * from "./Record.vue?vue&type=script&lang=ts&"
import style0 from "./Record.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports